<p>Other organizations besides {{asset.organization_name}} can be granted access to this asset.</p>
@if (assetPartners && assetPartners.length) {
<div class="mb-5">
	<div class="section-title">Current partner organizations:</div>
	<table class="log">
		<thead>
			<tr>
				<th>Organization name</th>
				<th>Delete</th>
			</tr>
		</thead>
		@for (partner of assetPartners; track partner) {
		<tbody>
			<tr>
				<td>{{partner.name}}</td>
				<td>
					<app-action-button [action]="DeletePartner" [args]="[partner.organization_id]" [context]="this" confirm="Revoke asset access from {{partner.name}}?" processing="..."
						btnClass="icon red" title="Delete partnership"><i class="icon-trash"></i></app-action-button>
				</td>
			</tr>
		</tbody>
		}
	</table>
</div>
}
<div class="section-title">Add a partner organization</div>
<div class="row">
	<div class="col-sm-8">
		<select [(ngModel)]="addPartnerOrg" class="form-control">
			@for (org of assetPotentialPartners; track org) {
			<option [ngValue]="org">{{org.name}}</option>
			}
		</select>
	</div>
	<div class="col-sm-4">
		<app-action-button [action]="AddPartner" [disabled]="!addPartnerOrg" [context]="this" processing="Sharing..." complete="Asset shared">Share asset
		</app-action-button>
	</div>
</div>